import React, { useState, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";

import arrow1 from "../../assets/images/icon/arrow-1.svg";
import ApplicantChart from "./ApplicantChart";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { Trans, useTranslation } from "react-i18next";

const TableComponent = props => {
  const { t } = useTranslation();
  const [chartSwitch, setChartSwitch] = useState(false);
  const disableViewAll = props?.disableViewAll || false;

  const columns = [
    
    {
      dataField: "name",
      text: t(`Recruiter_Report_Title.Recruiter_Title`),
      classes: "job-title pendinguser-cardss text-left white-space-nowrap",
      headerClasses: "pendinguser-cardss text-left white-space-nowrap"
    },
    {
      dataField: "totalApplicants",
      text: t(`Dashboard.Total`),
      classes: "total text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "status_breakdown.pending",
      text: t(`Dashboard.New`),
      classes: "pending text-center  pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },

    {
      dataField: "underAssessment",
      text: t(`Dashboard.Under Assessment`),
      classes: "under-assessment text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "status_breakdown.selected",
      text: t(`Dashboard.Selected`),
      classes: "selected-number text-cente pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "status_breakdown.onboarding",
      text: t(`Dashboard.Onboard`),
      classes: "on-board text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "status_breakdown.hold",
      text: t(`Dashboard.On Hold`),
      classes: "on-hold text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    {
      dataField: "status_breakdown.rejected",
      text: t(`Dashboard.Rejected`),
      classes: "rejected text-center pendinguser-cards",
      headerClasses: "text-center pendinguser-cards",
    },
    // Add more columns as needed
  ];



  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Dashboard.Showing rows`, { from, to, size })}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };


  // Process data to include underAssessment field
  const processedData = props?.data.map(item => ({
    ...item,
    underAssessment: item?.status_breakdown?.screening + item?.status_breakdown?.scheduled
  }));

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="vacancy-tabel timetohires  vacancytables">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="eligible-content">
              <h3 className="d-flex align-items-center gap-2 heading-one">
                {t(`Recruiter_Report_Title.Main_Report_Title`)}
              </h3>

              <div className="vacancy-table-row d-flex gap-2">
                <div className="tale-text right-panel">
                  <button
                    className="button left"
                    onClick={() => handleScroll("left")}
                    data-tooltip="Scroll Left"
                  >
                    <img src={right_arrow} alt="right-arrow" />
                  </button>
                  <button
                    className="button right"
                    onClick={() => handleScroll("right")}
                    data-tooltip="Scroll Right"
                  >
                    <img src={right_arrow} alt="right arrow 1" />
                  </button>
                </div>

                <h6 className="d-flex gap-3">
                  {/* <div>
                  <div className="notibtn mt-0 d-flex align-items-center gap-2">
                    <span className="notilab mr-2">Table</span>
                    <label className="switch" htmlFor={"chartSwitch"}>
                      <input
                        type="checkbox"
                        id={`chartSwitch`}
                        onClick={event => {
                          event.persist();
                          setChartSwitch(event.target.checked);
                        }}
                        defaultChecked={chartSwitch || false}
                      />
                      <div className="slider round"></div>
                    </label>
                    <span className="notilab ml-2">Chart</span>
                  </div>
                </div> */}

                  {!disableViewAll && (
                    <Link
                      to="/position-application"
                      className="gap-2 d-flex align-items-center view_link"
                    >
                      {t(`Dashboard.View All`)} <img src={arrow1} alt="Arrow" />
                    </Link>
                  )}
                </h6>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="tabel-application tabel-application-auto table-responsive minimum-height-card pb-3  center-content-s">
              <div className="timeto-hire-card userlist">
                <div className="table-custome-class range-custome">
                  <div className="scroll-container">
                    <div className="table-pending-list">

                      {processedData?.length > 0 && (
                        <div
                          className="table-wrapper"
                          ref={tableWrapperRef}
                        >
                          <BootstrapTable
                            keyField="id"
                            data={processedData}
                            columns={columns}
                            pagination={paginationFactory(options)}
                            rowClasses={rowClasses}
                          />
                        </div>
                      )}
                      {processedData?.length === 0 && (
                        // <p className="text-center">No Data Available.</p>
                        <div className="no-data data-available">
                          <img
                            src="../img/data-not-available.png"
                            alt="data not availble"
                          />
                          <h3>{t(`Dashboard.No Item Found`)}</h3>
                          <p>
                            <Trans>{t(`Dashboard.No Item Msg`)}</Trans>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableComponent;
